import { render } from "./JobItem.vue?vue&type=template&id=2f0a8e0a"
import script from "./JobItem.ts?vue&type=script&lang=js"
export * from "./JobItem.ts?vue&type=script&lang=js"

import "./JobItem.vue?vue&type=style&index=0&id=2f0a8e0a&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__